import { render, staticRenderFns } from "./PrintTreatmentsModal.vue?vue&type=template&id=ce0a7926&"
import script from "./PrintTreatmentsModal.vue?vue&type=script&lang=ts&"
export * from "./PrintTreatmentsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports